import React, { useEffect, useState } from "react";
import { Input } from "../common/Input";
import { searchHousing } from "./utils.ts";

export const Search = ({
  housings,
  onResult,
  placeholder = "поиск по названию",
  value,
  onChange,
}) => {
  const [internalTarget, setInternalTarget] = useState("");
  const target = value === undefined ? internalTarget : value;
  const handleTargetChange = onChange || setInternalTarget;

  useEffect(() => {
    if (target) {
      onResult(searchHousing(housings, target));
    } else {
      onResult(housings);
    }
  }, [housings, onResult, target]);

  return (
      <div className="mt-4 mb-2">
        <Input
            value={target}
            onChange={handleTargetChange}
            placeholder={placeholder}
        />
      </div>
  );
};
